const analyticsClient = window.analytics;

const initAnalyticsClient = (mfgId) => {
  // We aren't in control of the original analytics init so we stuff in our values here
  if (mfgId > 0) {
    analyticsClient.mfgId = mfgId;
    window.analytics = analyticsClient;
  }
  return window.analytics;
};

const getAnalyticsClient = mfgId => (
  analyticsClient || initAnalyticsClient(mfgId)
);

export const pageView = (data) => {
  getAnalyticsClient().pv(data);
};

/** @type {SendEvent} */
export const sendEvent = (action, data, version, mfgId) => {
  const mergedData = { mfgId, ...(data || {}) };
  return getAnalyticsClient(mergedData.mfgId).sendEvent(action, mergedData, version);
};

export const sendAnalyticsEvent = (eventName, orgId, additionalData = {}) => {
  let analyticsData = {};

  // fix improper usage
  if (typeof orgId === 'object') {
    analyticsData = { ...orgId, ...additionalData };
  } else {
    analyticsData = {
      mfgId: orgId,
      ...additionalData,
    };
  }

  sendEvent(eventName, analyticsData, undefined, +orgId || analyticsData.mfgId);
};

export const sendBulkEvent = (action, data = []) => {
  getAnalyticsClient().sendBulkEvents(action, data);
};
